import { IExperiments } from '../../types/reducers/experiments';
import { TExperimentsGroups, TExperimentsNames } from '../../constants/experiments';

export function isExperimentActive(
  experiments: IExperiments,
  experimentName: TExperimentsNames,
  groupName: TExperimentsGroups,
): boolean {
  return experiments[experimentName] === groupName;
}
